<div class="page-overlay-wrapper" *ngIf="showSpinner">
    <div class="bee-spinner"></div>
</div>